// Vytvoreni potrebnych onjektu z nactenych textur.
import {
    madnes_get_json,
    madnes_set_hand_cursor,
    madnes_set_input_down, madnes_set_input_up,
    madnes_set_win_factors
} from "../framework/src/engine/madnes/madnes";
import {
    he,
    picture_convert,
    reels_lenghts,
    reels_pos,
    behavior_config,
    server_config,
    wi
} from "../framework/src/engine/madnes/madnes_variables";
import {
    madnes_add_graphics,
    madnes_graphics_begin_fill,
    madnes_graphics_draw_rectangle
} from "../framework/src/engine/madnes/madnes_draw";
import {hide_black_screen} from "./ps_core_res_ctrl";
import {madnes_audio_allow_multiple, madnes_audio_loop} from "../framework/src/engine/madnes/madnes_audio";
import {infomenu_init} from "./ps_infomenu";
import {start_standing_symbols, unset_multiplier} from "./ps_anims";
import {
    madnes_loader_add_audio, madnes_loader_add_json_atlas,
    madnes_loader_create, madnes_loader_set_oncomplete,
    madnes_loader_start
} from "../framework/src/engine/madnes/madnes_loader";
import {audioPath, post_load_audio_win_symbols, post_load_json_atlas_standing} from "./adapters/madnesAssetsAdapter";
import {
    madnes_add_child,
    madnes_add_group,
    madnes_add_img,
    madnes_add_sprite,
    madnes_add_to_group,
    madnes_set_alpha,
    madnes_set_angle, madnes_set_cstm_val,
    madnes_set_img_center,
    madnes_set_pos,
    madnes_set_visible,
    madnes_sprite_set_frame_name
} from "../framework/src/engine/madnes/madnes_object";
import {madnes_add_bitmap_text, madnes_add_text, madnes_set_text_shadow} from "../framework/src/engine/madnes/madnes_text";
import {cylinder_pos} from "./ps_config";
import {stopposin, stopposin_old} from "./ps_core";
import {
    mystery_buttons_disabled,
    mystery_win_start,
    set_mystery_buttons_disabled,
    stop_mystery_click_timeout
} from "./ps_mystery";



export function ps_print_desk()
{
    //set_sounds();

    if(typeof behavior_config.reel.spin.motionBlur == "undefined")
    {
        behavior_config.reel.spin.motionBlur = 1;
    }

    if(typeof behavior_config.reel.spin.timeToReachFullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    if(typeof behavior_config.reel.spin.timeToReachNullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    if(typeof behavior_config.reel.acceleration.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.moveTime;
    }

    if(typeof behavior_config.reel.brake.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.brake.moveTime;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
    }

    madnes_set_win_factors(
        behavior_config.reel.minBigWinFactor,
        behavior_config.reel.minMegaWinFactor,
        behavior_config.reel.minSuperMegaWinFactor
    );

//	if(
//		typeof server_config.logic != "undefined" &&
//		typeof server_config.logic.bet_set != "undefined"
//	)
//	{
//		//madnes_init_bets(server_config.logic.bet_set);
//	}

    madnes_add_img("background", "background", 0, 0);

    for(var i = 0; i <= 6; i++)
    {
        madnes_add_img("reel_scatter_" + i, "reels_atlas", -9999, -9999, 0);
        madnes_sprite_set_frame_name("reel_scatter_" + i, "rells-BONUS");
        madnes_set_visible("reel_scatter_" + i, false);

        madnes_add_img("reel_mystery_" + i, "reels_atlas", -9999, -9999, 0);
        madnes_sprite_set_frame_name("reel_mystery_" + i, "rells-MYSTERY");
        madnes_set_visible("reel_mystery_" + i, false);
    }
    ////////////////////////////////////////////////////////////////////////////////

    // Nastaveni / vytvoreni pasu pro valce podle navratu ze serveru
    for(var i = 0; i < cylinder_pos.length; i++)
    {
        for(var j in server_config.logic.reels[i])
        {
            madnes_add_sprite("reels_bufer_" + i + "_" + j, "symbols_atlas", cylinder_pos[i], -9999);
            madnes_sprite_set_frame_name("reels_bufer_" + i + "_" + j, picture_convert[server_config.logic.reels[i][j]] + "_blur");

            reels_lenghts[i] = j * 1 + 1;
            stopposin[i] = reels_lenghts[i];
            stopposin_old[i] = reels_lenghts[i];
        }

        // S0-S2 = priprava vyherni pozice na kazdem valci
        for(var j = 0; j < 3; j++) {
            madnes_add_sprite("reels_bufer_" + i + "_S" + j, "symbols_atlas", cylinder_pos[i], -9999);
            madnes_sprite_set_frame_name("reels_bufer_" + i + "_S" + j, get_reel_symbol_name(server_config.matrix.reelMatrix, i, 2 - j));
        }

        reels_pos[i] = 0;
    }

    // // scaling testing
    // madnes_set_input_down("reels_bufer_" + 2 + "_S" + 1, () => {
    // 	console.log("reels_bufer_" + 2 + "_S" + 1);
    // 	madnes_set_visible("reels_bufer_" + 2 + "_S" + 1, false);
    // 	setTimeout(() => {
    // 		madnes_set_visible("reels_bufer_" + 2 + "_S" + 1, true);
    // 	}, 1000)
    // });

    madnes_add_graphics("black_screen_graphics", 0, 0);
    madnes_graphics_begin_fill("black_screen_graphics", 0x000000);
    madnes_graphics_draw_rectangle("black_screen_graphics", 0, 0, wi, he);
    madnes_set_alpha("black_screen_graphics", 0.7);
    hide_black_screen();

    for(var i = 0; i < cylinder_pos.length; i++) {

        for(var j = 0; j < 3; j++) {
            madnes_add_sprite("reels_bufer_" + i + "_TMP" + (2-j), "symbols_atlas", cylinder_pos[i], -9999);
            //madnes_sprite_set_frame_name("reels_bufer_" + i + "_TMP" + (2-j), picture_convert[server_config.logic.failResult[i][j]] + "_blur");
        }
    }

    madnes_add_img("mystery_background", "mystery_background", -9999, -9999);
    madnes_set_visible("mystery_background", false);

    madnes_add_img("mystery_img_rope_left", "mystery_atlas", 0, 0, 1, 0.5, 0);
    madnes_sprite_set_frame_name("mystery_img_rope_left", "mystery-rope-left");

    madnes_add_sprite("mystery_img_choose_left", "symbols_atlas", 0, 110, 1, 0.5, 0);
    madnes_sprite_set_frame_name("mystery_img_choose_left", "symbol_Mystery");
    madnes_set_input_down("mystery_img_choose_left", mystery_choose_left);
    madnes_set_hand_cursor("mystery_img_choose_left", true);

    madnes_add_group("mystery_choose_left_group");
    madnes_add_to_group("mystery_choose_left_group", "mystery_img_rope_left");
    madnes_add_to_group("mystery_choose_left_group", "mystery_img_choose_left");
    madnes_set_pos("mystery_choose_left_group", -9999, -9999);
    madnes_set_visible("mystery_choose_left_group", false);
    madnes_set_angle("mystery_choose_left_group", 0);

    madnes_add_img("mystery_img_rope_middle", "mystery_atlas", 0, 0, 1, 0.5, 0);
    madnes_sprite_set_frame_name("mystery_img_rope_middle", "mystery-rope-middle");

    madnes_add_sprite("mystery_img_choose_middle", "symbols_atlas", -9999, -9999, 1, 0.5, 0);
    madnes_sprite_set_frame_name("mystery_img_choose_middle", "symbol_Mystery");
    madnes_set_input_down("mystery_img_choose_middle", mystery_choose_middle);
    madnes_set_hand_cursor("mystery_img_choose_middle", true);

    madnes_add_group("mystery_choose_middle_group");
    madnes_add_to_group("mystery_choose_middle_group", "mystery_img_rope_middle");
    madnes_add_to_group("mystery_choose_middle_group", "mystery_img_choose_middle");
    madnes_set_pos("mystery_choose_middle_group", -9999, -9999);
    madnes_set_visible("mystery_choose_middle_group", false);
    madnes_set_angle("mystery_choose_middle_group", 0);

    madnes_add_img("mystery_img_rope_right", "mystery_atlas", 0, 0, 1, 0.5, 0);
    madnes_sprite_set_frame_name("mystery_img_rope_right", "mystery-rope-right");

    madnes_add_sprite("mystery_img_choose_right", "symbols_atlas", -9999, -9999, 1, 0.5, 0);
    madnes_sprite_set_frame_name("mystery_img_choose_right", "symbol_Mystery");
    madnes_set_input_down("mystery_img_choose_right", mystery_choose_right);
    madnes_set_hand_cursor("mystery_img_choose_right", true);

    madnes_add_group("mystery_choose_right_group");
    madnes_add_to_group("mystery_choose_right_group", "mystery_img_rope_right");
    madnes_add_to_group("mystery_choose_right_group", "mystery_img_choose_right");
    madnes_set_pos("mystery_choose_right_group", -9999, -9999);
    madnes_set_visible("mystery_choose_right_group", false);
    madnes_set_angle("mystery_choose_right_group", 0);

    var labelTextStyle = {
        'font': "40px Calibri",
        //'fontSize': ,
        'stroke': "#000000",
        'strokeThickness': 3,
        'fill': "#FFFFFF",
        'align': "left",
        'boundsAlignH': "left",
        'boundsAlignV': "top",
        'wordWrap': false,
        'wordWrapWidth': 300
    };

    var chooseLabelText = "";
    var buttons = madnes_get_json("infotext")["buttons"];

    if(buttons && buttons["mystery_select"]) {
        chooseLabelText = buttons["mystery_select"]["content"];
    }

    madnes_add_img("mystery_label", "mystery_atlas", -9999, -9999, 1, 0.5, 0);
    madnes_sprite_set_frame_name("mystery_label", "mystery-label");
    madnes_set_visible("mystery_label", false);

    madnes_add_img("mystery_btn_choose_left", "mystery_atlas", -9999, -9999);
    madnes_sprite_set_frame_name("mystery_btn_choose_left", "btn_choose_basic");
    madnes_set_img_center("mystery_btn_choose_left", 0.5, 0.5);
    madnes_add_text("mystery_btn_choose_left_label", 0, 0, chooseLabelText, labelTextStyle);
    madnes_set_img_center("mystery_btn_choose_left_label", 0.5, 0.5);
    madnes_add_child("mystery_btn_choose_left", "mystery_btn_choose_left_label");

    madnes_set_visible("mystery_btn_choose_left", false);
    madnes_add_bitmap_text("mystery_win_txt_left", "font_winplane", -9999, -9999, "0", 80);
    madnes_set_visible("mystery_win_txt_left", false);
    //madnes_add_text("mystery_win_txt_left", 199, 508, "666", mystery_txt_style);
    madnes_set_img_center("mystery_win_txt_left", 1, 1);


    madnes_add_img("mystery_btn_choose_middle", "mystery_atlas", -9999, -9999);
    madnes_sprite_set_frame_name("mystery_btn_choose_middle", "btn_choose_basic");
    madnes_set_img_center("mystery_btn_choose_middle", 0.5, 0.5);
    madnes_add_text("mystery_btn_choose_middle_label", 0, 0, chooseLabelText, labelTextStyle);
    madnes_set_img_center("mystery_btn_choose_middle_label", 0.5, 0.5);
    madnes_add_child("mystery_btn_choose_middle", "mystery_btn_choose_middle_label");

    madnes_set_visible("mystery_btn_choose_middle", false);
    madnes_add_bitmap_text("mystery_win_txt_middle", "font_winplane", -9999, -9999, "0", 80);
    madnes_set_visible("mystery_win_txt_middle", false);
    //madnes_add_text("mystery_win_txt_middle", 533, 508, "666", mystery_txt_style);
    madnes_set_img_center("mystery_win_txt_middle", 1, 1);


    madnes_add_img("mystery_btn_choose_right", "mystery_atlas", -9999, -9999);
    madnes_sprite_set_frame_name("mystery_btn_choose_right", "btn_choose_basic");
    madnes_set_img_center("mystery_btn_choose_right", 0.5, 0.5);
    madnes_add_text("mystery_btn_choose_right_label", 0, 0, chooseLabelText, labelTextStyle);
    madnes_set_img_center("mystery_btn_choose_right_label", 0.5, 0.5);
    madnes_add_child("mystery_btn_choose_right", "mystery_btn_choose_right_label");

    madnes_set_visible("mystery_btn_choose_right", false);
    madnes_add_bitmap_text("mystery_win_txt_right", "font_winplane", -9999, -9999, "0", 80);
    madnes_set_visible("mystery_win_txt_right", false);
    //madnes_add_text("mystery_win_txt_right", 867, 508, "666", mystery_txt_style);
    madnes_set_img_center("mystery_win_txt_right", 1, 1);

    madnes_set_input_down("mystery_btn_choose_left", function() {
        madnes_sprite_set_frame_name("mystery_btn_choose_left", "btn_choose_pressed");
    });

    madnes_set_input_up("mystery_btn_choose_left", mystery_choose_left);
    madnes_set_hand_cursor("mystery_btn_choose_left", true);

    madnes_set_input_down("mystery_btn_choose_middle", function() {
        madnes_sprite_set_frame_name("mystery_btn_choose_middle", "btn_choose_pressed");
    });

    madnes_set_input_up("mystery_btn_choose_middle", mystery_choose_middle);
    madnes_set_hand_cursor("mystery_btn_choose_middle", true);

    madnes_set_input_down("mystery_btn_choose_right", function() {
        madnes_sprite_set_frame_name("mystery_btn_choose_right", "btn_choose_pressed");
    });

    madnes_set_input_up("mystery_btn_choose_right", mystery_choose_right);
    madnes_set_hand_cursor("mystery_btn_choose_right", true);

    madnes_add_group("bigwin_group");
    madnes_set_pos("bigwin_group", wi / 2, 320); //-9999, -9999); // wi / 2, 320
    madnes_add_img("big_win_rope_left", "big_win_rope", -290, 10, 1, 0.5, 1);
    madnes_add_img("big_win_rope_right", "big_win_rope", 290, -15, 1, 0.5, 1);

    madnes_add_img("big_win", "big_win", -9999, -9999, 1 , 0.5, 0.5);

    madnes_add_img("mega_win", "mega_win", -9999, -9999, 1, 0.5, 0.5);
    madnes_set_visible("mega_win", false);

    madnes_add_img("super_mega_win", "super_mega_win", -9999, -9999, 1, 0.5, 0.5);
    madnes_set_visible("super_mega_win", false);

    madnes_add_img("free_spins", "free_spins", wi / 2, -9999, 1, 0.5, 0.5);
    madnes_set_visible("free_spins", false);

    var yfsw = "";
    var texts = madnes_get_json("infotext")["texts"];

    if(texts && texts["fs_win"]) {
        yfsw = texts["fs_win"]["content"];
    }

    madnes_add_text("text_your_free_spins_win", wi / 2, he / 2 + 10, yfsw, {
        'font': "34px Calibri",
        'stroke': "#000000",
        'strokeThickness': 3,
        'fill': "#FFFFFF",
        'align': "left",
        'boundsAlignH': "left",
        'boundsAlignV': "top",
        'wordWrap': false,
        'wordWrapWidth': 300
    });
    madnes_set_text_shadow("text_your_free_spins_win", 2, 2, 'rgba(0,0,0,0.5)', 5, null, null);
    madnes_set_img_center("text_your_free_spins_win", 0.5, 0.5);
    madnes_set_visible("text_your_free_spins_win", false);

    madnes_add_bitmap_text("bigwin_text", "font_bigwin", 0, 68, "0", 74);
    //madnes_add_bitmap_text("bigwin_text", "font_bigwin", 0, 60, "0", 70);

    madnes_set_img_center("bigwin_text", 0.5, 0.5);
    madnes_add_to_group("bigwin_group", "big_win_rope_left");
    madnes_add_to_group("bigwin_group", "big_win_rope_right");
    madnes_add_to_group("bigwin_group", "big_win");
    madnes_add_to_group("bigwin_group", "mega_win");
    madnes_add_to_group("bigwin_group", "super_mega_win");
    madnes_add_to_group("bigwin_group", "free_spins");
    madnes_add_to_group("bigwin_group", "text_your_free_spins_win");

    madnes_add_to_group("bigwin_group", "bigwin_text");
    madnes_set_visible("bigwin_group", false);

    //set_bigwin_type("free_spins");

    madnes_audio_allow_multiple("remittance_A");

    for(var i = 0; i < cylinder_pos.length; i++) {
        for(var j = 0; j <= 2; j++) {
            madnes_add_sprite("reels_bufer_" + i + "_STND" + (2-j), "symbols_atlas", cylinder_pos[i], -9999);
            madnes_sprite_set_frame_name("reels_bufer_" + i + "_STND" + (2-j), get_reel_symbol_name(server_config.matrix.reelMatrix, i, j));
        }
    }

    madnes_add_img("reel_left", "reels_atlas", 0, 0);
    madnes_sprite_set_frame_name("reel_left", "reel_cover_left");

    madnes_add_img("reel_right", "reels_atlas", wi, 0);
    madnes_set_img_center("reel_right", 1, 0);
    madnes_sprite_set_frame_name("reel_right", "reel_cover_right");

    madnes_add_img("reel_top", "reels_atlas", 102, 0);
    madnes_sprite_set_frame_name("reel_top", "reel_cover_top");

    madnes_add_img("reel_bottom", "reels_atlas", 102, he);
    madnes_set_img_center("reel_bottom", 0, 1);
    madnes_sprite_set_frame_name("reel_bottom", "reel_cover_bottom");

    madnes_add_img("logo_reels", "reels_atlas", wi / 2, -10, 1, 0.5, 0);
    madnes_sprite_set_frame_name("logo_reels", "logo_reels");

    madnes_add_bitmap_text("fs_count", "font_freespin", 140, 54, "0/0", 74);
    madnes_set_img_center("fs_count", 0.5, 1);

    madnes_add_img("fs_board", "reels_atlas", 0, 0, 1, 0.5, 0);
    madnes_sprite_set_frame_name("fs_board", "free-spins_background");

    madnes_add_group("fs_group");
    madnes_set_pos("fs_group", wi / 2, -9999); // wi / 2, 600); -9999, -9999
    madnes_add_to_group("fs_group", "fs_board");
    madnes_add_to_group("fs_group", "fs_count");
    madnes_set_visible("fs_group", false);

    madnes_set_cstm_val("fs_group", { 'hided': true });

    madnes_add_group("multiplier_group");
    madnes_add_img("multiplier_bg", "reels_atlas", 0, 0, 1, 0.5, 0);
    madnes_sprite_set_frame_name("multiplier_bg", "multiplier_background");
    madnes_add_to_group("multiplier_group", "multiplier_bg");

    for(var i = 2; i <= 5; i++)
    {
        madnes_add_img("multiplier_x" + i, "reels_atlas", 0, 0, 1, 0.5, 0);
        madnes_sprite_set_frame_name("multiplier_x" + i, "multiplier_x" + i);
        madnes_add_to_group("multiplier_group", "multiplier_x" + i);
    }

    madnes_set_pos("multiplier_group", wi / 2, -9999);
    madnes_set_visible("multiplier_group", false);

    madnes_set_cstm_val("multiplier_group", { 'hided': true, 'multi': 1 });

    unset_multiplier();

    //hide_fs_anim(function() {});
    //add_free_spins_anim(function() {});
    madnes_audio_loop("BACKGROUND");

    hide_all_stand_symbols();
    //start_standing_symbols();

    //add_touchdown_to_desk();


    madnes_loader_create('win_symbols_audio');
    for(var audio in post_load_audio_win_symbols) {
        madnes_loader_add_audio('win_symbols_audio', audio, post_load_audio_win_symbols[audio]);
    }
    madnes_loader_start('win_symbols_audio');


    madnes_loader_create('fs_audio_bg');
    madnes_loader_add_audio('fs_audio_bg', 'BACKGROUND_FS', audioPath + 'bg_FreeSpins.ogg');
    madnes_loader_start('fs_audio_bg');


    madnes_loader_create('myst_audio_bg');
    madnes_loader_add_audio('myst_audio_bg', 'mystery_background', audioPath + 'bg_Mystery.ogg');
    madnes_loader_start('myst_audio_bg');

    madnes_loader_create('stand_anim');
    for(var key in post_load_json_atlas_standing) {
        madnes_loader_add_json_atlas('stand_anim', key, post_load_json_atlas_standing[key][0], post_load_json_atlas_standing[key][1]);
    }

    madnes_loader_start('stand_anim');

    // madnes_recount_bet();

    madnes_set_cstm_val("logo_reels", { hided: false });

    // madnes_popup_message(new MadnesError("3003", { msg: "sdfsdf" }));

//	setTimeout(function() {
// 		madnes_popup_message({ err_code: 5010, message: "Byla dosažena maximální výše sázky za 1 měsíc", "name": "Max. měsíční sázka", "desc": "Chcete zrušit nebo změnit své sebeomezující opatření?" });
// 		madnes_popup_message({ err_code: 5015, message: "Po uplynutí 120 minut se spustí 15 minutový časovač, kdy není možné otevřít další hru", "name": "Časovač spuštěn" });
// 		madnes_popup_message({ err_code: 5015 });
// 		madnes_popup_message({ err_code: -1, message: "Po uplynutí 120 minut se spustí 15 minutový časovač, kdy není možné otevřít další hru", "name": "Časovač spuštěn" })
//	}, 1000);

}

function hide_all_stand_symbols()
{
    for(var i = 0; i < cylinder_pos.length; i++) {
        for(var j = 0; j <= 2; j++) {
            madnes_set_visible("reels_bufer_" + i + "_STND" + (2-j), false);
        }
    }
}

function mystery_choose_left()
{
    if(mystery_buttons_disabled) {
        return false;
    }

    set_mystery_buttons_disabled(true);
    // mystery_buttons_disabled = true;

    stop_mystery_click_timeout();
    madnes_sprite_set_frame_name("mystery_btn_choose_right", "btn_choose_disabled");
    madnes_sprite_set_frame_name("mystery_btn_choose_middle", "btn_choose_disabled");
//		madnes_sprite_set_frame_name("mystery_btn_choose_left", "");
    mystery_win_start("left");
}

function mystery_choose_middle()
{
    if(mystery_buttons_disabled) {
        return false;
    }

    set_mystery_buttons_disabled(true);
    // mystery_buttons_disabled = true;

    stop_mystery_click_timeout();
    madnes_sprite_set_frame_name("mystery_btn_choose_right", "btn_choose_disabled");
    madnes_sprite_set_frame_name("mystery_btn_choose_left", "btn_choose_disabled");
    //madnes_sprite_set_frame_name("mystery_btn_choose_middle", "");
    mystery_win_start("middle");
}

function mystery_choose_right()
{
    if(mystery_buttons_disabled) {
        return false;
    }

    set_mystery_buttons_disabled(true);
    // mystery_buttons_disabled = true;

    stop_mystery_click_timeout();
    //madnes_sprite_set_frame_name("mystery_btn_choose_right", "");
    madnes_sprite_set_frame_name("mystery_btn_choose_left", "btn_choose_disabled");
    madnes_sprite_set_frame_name("mystery_btn_choose_middle", "btn_choose_disabled");
    mystery_win_start("right");
}

/*var _bet = 5;

var _win = 0;
var _currValue = 0;
var _bigWinValue = 25;
var _megaWinValue = 50;
var _superWinValue = 125;

var _step = 0.05;

var count_win_callback = function() {};
var count_win_update = function() {};

function count_win()
{
	var type;

	if(_currValue >= _superWinValue) {
		type = "s";
	} else if(_currValue >= _megaWinValue) {
		type = "m";
	} else {
		type = "b";
	}

	switch(type) {
		case "b":
			_currValue =
			Math.ceil(
				(_megaWinValue/2.7) * _step
			);

			break;
		case "m":
			_currValue =
			Math.ceil(
				(
					((_superWinValue-_megaWinValue)/_bet) * Math.exp((_step-(2.0*2.7)) * 0.1) +
					((_step-2.7)/2.7-1.0) *
					((_superWinValue-_megaWinValue)/_bet) * Math.exp(-2.7*0.1) +
					(_megaWinValue/_bet)
				) * _bet
			);

			break;

		case "s":
			_currValue =
				Math.ceil(
					(
						((_superWinValue-_megaWinValue)/_bet) * Math.exp((_step-(2.0*2.7))) +
						((_step-2.7)/2.7-1.0) *
						((_superWinValue-_megaWinValue)/_bet) * Math.exp(2.7) +
						(_megaWinValue/_bet)
					)*_bet
				);

			break;
	}

	count_win_update(_currValue);

	if(_currValue < _win) {
		_step += 0.05;
		setTimeout(count_win, 1000 / 30);
	} else {
		count_win_callback();
	}
}*/

function get_reel_symbol_name(reel, x, y) {
    /*if(reel.length === 1) {
     reel = reel[0];
     }*/

    return picture_convert[reel[x][y]];
}